module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_6.7d003960.png";